import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';
import Card          from '@common/influencer/_card';

// -------------------------------------------------------


class ProjectInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showSelectCandidateModal = this.showSelectCandidateModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal           : false,
      targets         : [],
    };
  }
  // -------------------------------------------------------
  
  showSelectCandidateModal(targets) { 
    let multi_select = [];
    targets.map((d) => { multi_select.push(d.insta_user_id); });
    
    let base = this.props.data;
    base.event.updateData.bind(this)('multi_select', multi_select);
    
    this.setState({ modal: true, targets: targets });
  }
  // -------------------------------------------------------
  
  closeAssignModal() {
    this.setState({ modal: false, targets: [] });
  }
  // -------------------------------------------------------
  
  removeAction(removeList) {
    let base = this.props.data;
    
    let chk = confirm('選択した'+ removeList.length +'人のインフルエンサーを候補から外してもよろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/workflow/remove_candidate', { project_id: base.project.id, ids: removeList },
      function(res){
        alert('該当のインフルエンサーを候補から除外しました');
        location.reload();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    let detail = base.project.detail;
    
    let influencers = [];
    this.state.targets.map((d) => {
      let inf = base.workflow.influencers[d.insta_user_id];
      if( inf != undefined ) influencers.push(inf);
    });
    
    if( influencers.length == 0 ) return null;
    console.log(base);
    
    let removeList = [];
    try {
      this.state.targets.map((d) => {
        if( base.multi_select.indexOf(d.insta_user_id) === -1 ) removeList.push(d.insta_user_id);
      });
    } catch(e) {}
    
    return (
      <div className="select-candidate-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {'calc(100% - 120px)'}
          height    = {'calc(100% - 120px)'}
          close_ev  = {this.closeAssignModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2>候補者リスト ({influencers.length})</h2>
              <h4>インフルエンサーを選択することでリンクとメッセージが表示されます</h4>
              
              <div className="influencer-list-box">
                <div className="influencer-list">
                  { influencers.map((d, key) => {
                    return <Card key={key} data={d} base={base} list={influencers} multi_action_flg={true} view_mode="post_module" />;
                  })}
                </div>
              </div>
              
              <div className="submit-box">
                { (removeList.length > 0)
                  ? <div className="button on" onClick={this.removeAction.bind(this, removeList)}>
                      リストから除外する ({removeList.length}人)
                    </div>
                  : <div className="button off">
                      リストから除外する ({removeList.length}人)
                    </div>
                }
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInfluencer;